export default __webpack_public_path__ + "9c5a939648cf4e10869c369c7262c0b2.woff2";